// removed by extract-text-webpack-plugin
module.exports = {"root":"_3KYqG","likeIcon":"_1U71j","iconBlock":"_1oSBD","active":"_-IM3n"};


//////////////////
// WEBPACK FOOTER
// ./app/containers/Post/components/PostContent/components/ContentBlock/components/SocialMedia/components/LikeBlock/LikeBlock.scss
// module id = 1183
// module chunks = 2